import { render, staticRenderFns } from "./LandingPageProducer.vue?vue&type=template&id=01d3513e&scoped=true"
import script from "./LandingPageProducer.vue?vue&type=script&lang=js"
export * from "./LandingPageProducer.vue?vue&type=script&lang=js"
import style0 from "./LandingPageProducer.vue?vue&type=style&index=0&id=01d3513e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3513e",
  null
  
)

export default component.exports